import React, { useEffect, useState } from 'react';
import axios from 'axios';

import InfoPage01 from './PageInfo01'
import InfoPage02 from './PageInfo02'
import PageQuestion01 from './PageQuestion01'
import InfoPage03 from './PageInfo03'
import InfoPage04 from './PageInfo04'
import InfoPage05 from './PageInfo05'

function App() {

  const pageTotal = 12
  const [config, setConfig] = useState([]);
  const [page, setPage] = useState(0);
  const [data, setData] = useState([
    {metadata: {
      width: window.innerWidth, 
      height: window.innerHeight,      
    }}
  ]);
  const [submitCode, setSubmitCode] = useState(undefined);
  const [vizOrder, setVizOrder] = useState(undefined);

  useEffect(() => {
    axios.get('api/config')
      .then((response) => {
        setConfig(response.data)
        setPage(1)
      })
      .catch((error) => {
        console.log(error);
      });
  },[])

  const nextPage = (pg_responses) => {
    if(typeof(pg_responses) === 'object'){
      let tmpArr = data;
      tmpArr.push(pg_responses)
      setData(tmpArr)
    }
    if(page === 15){
      axios.post('/api/submit', data)
      .then(function (response) {
        setSubmitCode(response.data.id)
        setPage(page + 1) 
      })
      .catch(function (error) {
        console.log(error);
        setPage(page + 1) 
      });
    } else {
      setPage(page + 1) 
    }
  }

  const renderSwitch = () => {
    if(vizOrder === undefined && config.length !== 0){
      let array = [...Array(config.data.length).keys()]
      array.sort(() => Math.random() - 0.5)
      setVizOrder(array)
    }
    switch(page) {

      case 0: nextPage(); return null;
      case 1: return(<InfoPage01 next={nextPage.bind(this)} />);
      case 2:
      case 3: 
      case 4: 
      case 5: 
      case 6: 
      case 7: 
      case 8: 
      case 9: 
      case 10: 
      case 11: 
      case 12: 
      case 13: return(
        <PageQuestion01
          viz={ config.data[ vizOrder[page - 2] ] } 
          viz_title={page - 2}
          pg_number={page-1} 
          pg_total={pageTotal} 
          next={nextPage.bind(this)} />
      );
      case 14: return(<InfoPage05 next={nextPage.bind(this)} />);
      case 15: return(<InfoPage03 next={nextPage.bind(this)} />);
      case 16: return(<InfoPage04 data={submitCode} />);
      default: return(<div><h2>Internal Error</h2></div>);
    }
  }

  return(renderSwitch());
}

export default App;
